import { useEffect, useRef, useState } from "react";

import { VideoCameraIcon } from '@ergeon/icons/hero/outline';

// One reserved box for both states: the placeholder icon and the live preview
// share the same aspect-video frame, so granting the camera changes what is
// inside the card, never its height — nothing below it moves.
export default function LobbyVideo({ videoStream }: { videoStream?: MediaStream }) {
  const videoRef = useRef<HTMLVideoElement>(null);
  // Faded in when frames actually render, not when the element mounts: a
  // mount-time animation plays over a still-black box and the picture then
  // pops in after it, which reads worse than no animation at all.
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(function assignVideoStreamToVideoElement() {
    if (videoStream && videoRef.current) {
      videoRef.current.srcObject = videoStream;
    }
    if (!videoStream) {
      setIsPlaying(false);
    }
  }, [videoStream]);

  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-2xl bg-black-2 shadow-lg ring-1 ring-black/5 dark:bg-gray-800 dark:ring-white/10">
      <div className="absolute inset-0 flex items-center justify-center">
        <VideoCameraIcon className="size-16 text-gray-500" />
      </div>
      {videoStream && (
        <video
          ref={videoRef}
          muted={true}
          autoPlay
          playsInline
          onPlaying={() => setIsPlaying(true)}
          // The lobby preview is always the front camera looking at the
          // customer, so it has to read like a mirror, same as the self-view
          // in the call.
          className={`absolute inset-0 size-full -scale-x-100 object-cover transition-opacity duration-200 ${
            isPlaying ? 'opacity-100' : 'opacity-0'
          }`}
        />
      )}
    </div>
  );
}
